import { configureStore } from "@reduxjs/toolkit";

import authReducer from "@/feature/auth/state/auth-slice";
import aiPlannerSlice from "@/feature/ai-planner/state/ai-planner-slice";
import flightRevalidateSlice from "@/feature/flight/checkout/state/revalidate.slice";
import extractFlightFilter from "@/feature/flight/search/state/slices/extract-flight-filter.slice";
import flightData from "@/feature/flight/search/state/slices/flight-data.slice";
import flightSearchSlice from "@/feature/flight/search/state/slices/flight-search-status.slice";
import extractHolidayFilter from "@/feature/holiday/search/state/extract-holiday-filter-slice";
import hotelCompareSlice from "@/feature/hotel/checkout/state/hotel-compare.slice";
import hotelDataSlice from "@/feature/hotel/checkout/state/hotel-data.slice";
import hotelRoomSlice from "@/feature/hotel/checkout/state/hotel-room.slice";
import extractHotelFilter from "@/feature/hotel/search/state/extract-hotel-filter-slice";
import hotelFormSlice from "@/feature/hotel/search/state/hotel-search-form-slice";
import customUmrahFlowSlice from "@/feature/umrah/custom/request/state/custom-umrah-flow.slice";
import notificationsReducer from "@/feature/notifications/state/notifications-slice";
import extractUmrahFilter from "@/feature/umrah/package/search/state/extract-umrah-filter-slice";
import globalTransitionSlice from "@/feature/transition/state/transition.slice";
import { baseApi } from "@/redux/api/base-api";
import appReducer from "./slices/app-slice";

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    app: appReducer,
    aiPlanner: aiPlannerSlice.reducer,
    auth: authReducer,
    // flight 
    flightData: flightData.reducer,
    flightRevalidate: flightRevalidateSlice.reducer,
    extractFlightFilter: extractFlightFilter.reducer,
    flightSearchStatus: flightSearchSlice.reducer,
    // holiday
    extractHolidayFilter: extractHolidayFilter.reducer,
    // umrah
    customUmrahFlow: customUmrahFlowSlice,
    extractUmrahFilter: extractUmrahFilter.reducer,
    notifications: notificationsReducer,
    // hotel
    extractHotelFilter: extractHotelFilter.reducer,
    selectedHotelData: hotelDataSlice.reducer,
    hotelRoomData: hotelRoomSlice.reducer,
    hotelForm: hotelFormSlice.reducer,
    hotelCompareAndQuotation: hotelCompareSlice.reducer,
    
    // global transitions
    globalTransition: globalTransitionSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        warnAfter: 128,
      },
      immutableCheck: {
        warnAfter: 128,
      },
    }).concat(baseApi.middleware),
});

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];



